import { Component, computed, inject } from "@angular/core"
import { RegionsService } from "../../../../regions/regions.service"
import { StorageService } from "../../../../services/storage.service"
import { UiThemeService } from "ui-theme"

@Component({
  imports: [],
  standalone: true,
  template: `
    @if (brandHeader(); as header) {
      <div class="column flex-1 justify-center items-end py-24 pr-[20%] text-right">
<!--        @if (header.title) {-->
<!--          <div class="text-6xl font-black">-->
<!--            {{ header.title }}-->
<!--          </div>-->
<!--        }-->
<!--        @if (header.subTitle) {-->
<!--          <div class="text-md">-->
<!--            {{ header.subTitle }}-->
<!--          </div>-->
<!--        }-->
        @if (header.image && brandHeaderImage()) {
          <div
            class="p-2 rounded-lg"
            [style.width]="header.style.width"
          >
            <img
              [src]="brandHeaderImage()"
              [alt]="header.image.altText"
            />
          </div>
        }
      </div>
    }
  `,
  selector: "e2e-header-brand",
})
export class HeaderBrandComponent {
  private regionService = inject(RegionsService)
  private storageService = inject(StorageService)
  private uiThemeService = inject(UiThemeService)

  brandHeader = this.regionService.brandHeader
  brandHeaderImage = computed(() =>
    this.storageService.getFileUrl(
      this.uiThemeService.isLightMode()
        ? this.brandHeader()?.image.srcLightMode
        : this.brandHeader()?.image.srcDarkMode,
    ),
  )
}
